import styles from "./ShortFormListTable.module.scss"

import React, { useEffect, useState } from "react"

import { shortsApi } from "@shared/apis"
import {
  getShortsValidateErrorMessage,
  hasShortsPermission,
  ShortsListItem,
  validateShortsEntry,
} from "@shared/apis/shorts"
import { WownetExecuteShortsLink } from "@shared/components"
import { useLayerPopupContext } from "@shared/contexts"

import dayjs from "dayjs"

import AiSummaryPopup from "./AiSummaryPopup"
import AiIcon from "./icons/AiIcon"
import VodIcon from "./icons/VodIcon"
import ShortFormListTable from "./ShortFormListTable"

export default function ShortForm({
  height,
  streamerId,
  streamerNickname,
  refreshTrigger,
  isStreamerView,
}: {
  height?: number
  streamerId?: number
  streamerNickname?: string
  refreshTrigger?: number
  isStreamerView?: boolean
}) {
  const { open } = useLayerPopupContext()

  const [shorts, setShorts] = useState<ShortsListItem[]>([])
  const [isLoaded, setIsLoaded] = useState(false)
  const [selectedShortForm, setSelectedShortForm] =
    useState<ShortsListItem | null>(null)

  useEffect(() => {
    if (!streamerId) return

    shortsApi.getShortsList(streamerId).then((result) => {
      // id가 없는 숏폼(처리 미완료 등)은 재생 링크를 만들 수 없어 목록에서 제외
      // id가 null일순 없을것 같은데 백엔드에서 전달해준 스펙상 그렇다고 함...
      setShorts(result.data.filter((item) => item.id !== null))
      setIsLoaded(true)
    })
  }, [streamerId, refreshTrigger])

  const openAiSummary = async (item: ShortsListItem) => {
    if (!item.id) return

    try {
      const entry = await validateShortsEntry(item.id)

      if (!hasShortsPermission(entry)) {
        open("SUBSCRIBE_INFO")
        return
      }
    } catch (err) {
      alert(getShortsValidateErrorMessage(err))
      return
    }

    setSelectedShortForm(item)
  }
  const closeAiSummary = () => setSelectedShortForm(null)

  return (
    <>
      <ShortFormListTable height={height}>
        {isLoaded && !shorts.length && (
          <li className={styles.empty}>
            {/* 스트리머 화면은 본인이 생성하는 기준이라 문구가 다름 */}
            {isStreamerView
              ? "생성된 숏폼이 존재하지 않습니다."
              : "시청 가능한 숏폼이 존재하지 않습니다."}
          </li>
        )}
        {shorts.map((short, index) => (
          <li className={styles.item} key={short.id ?? index}>
            <span className={styles.date}>
              {short.createdAt
                ? dayjs(short.createdAt).format("YYYY-MM-DD")
                : "-"}
            </span>
            <div className={styles.body}>
              <p className={styles.title} title={short.title ?? ""}>
                {short.title}
              </p>
              {!isStreamerView && (
                <div className={styles.actions}>
                  {short.id && (
                    <WownetExecuteShortsLink
                      shortsId={short.id}
                      title="재생"
                      className={styles.iconButton}
                    >
                      <VodIcon />
                    </WownetExecuteShortsLink>
                  )}
                  <button
                    type="button"
                    className={styles.iconButton}
                    title="AI요약"
                    onClick={() => openAiSummary(short)}
                  >
                    <AiIcon />
                  </button>
                </div>
              )}
            </div>
          </li>
        ))}
      </ShortFormListTable>

      {!isStreamerView && selectedShortForm && (
        <AiSummaryPopup
          item={selectedShortForm}
          streamerNickname={streamerNickname ?? "-"}
          onClose={closeAiSummary}
        />
      )}
    </>
  )
}
